import { createContext, useContext, useState, useEffect } from 'react';
import { getMeApi, loginApi, registerApi } from '../api/authApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ts_token');
    if (!token) { setLoading(false); return; }
    getMeApi()
      .then((res) => setUser(res.data.data.user))
      .catch(() => localStorage.removeItem('ts_token'))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await loginApi({ email, password });
    localStorage.setItem('ts_token', res.data.token);
    setUser(res.data.data.user);
    return res.data;
  };

  const register = async (payload) => {
    const res = await registerApi(payload);
    if (res.data.token) {
      localStorage.setItem('ts_token', res.data.token);
      setUser(res.data.data.user);
    }
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('ts_token');
    setUser(null);
  };

  const updateUser = (updatedUser) => setUser(updatedUser);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};
